/* eslint-disable no-console */
import React from 'react';
import HBTTableCell from 'Feature/V2/HbtPortfolioManagement/components/HbtPortfolioManagementTable/components/HBTTableCell';
import { TFunction } from 'i18next';
import { CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import { Tooltip } from '@mui/material';
import styles from './styles.module.scss';

export const createColumn =
  (t: TFunction) =>
  ({ cell, row }: { cell: any; row: any }) => {
    const value = cell.getValue();
    return <HBTTableCell title={value}>{value}</HBTTableCell>;
  };

export const createFirstColumn =
  (t: TFunction) =>
  ({ cell, row }: { cell: any; row: any }) => {
    const value = cell.getValue();
    const tooltipKeys = ['premiumFlatRatePercent', 'totalLoanCount'];
    if (tooltipKeys.includes(row.original.key)) {
      return (
        <HBTTableCell>
          {value}
          <Tooltip
            title={
              row.original.key === 'totalLoanCount'
                ? t('Number-of-loans-with-an-approved-status')
                : t('After-applying-any-premium-discount')
            }
            placement="top"
            arrow
            slotProps={{
              tooltip: {
                className: styles.pricingScenarioToolTip
              },
              arrow: {
                className: styles.tooltipArrow
              }
            }}
          >
            <div
              className={styles.scenarioToolTip}
              style={{
                display: 'inline-block',
                marginLeft: '8px'
              }}
            >
              <CmhcIcon size={CmhcIconSize.SMALL} type="icon_info_outlined" />
            </div>
          </Tooltip>
        </HBTTableCell>
      );
    }
    return <HBTTableCell title={value}>{value}</HBTTableCell>;
  };
